import React from 'react';
import '../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import Footer from '../includes/Footer';
import TermsItem from './TermsItem';
import styled from 'styled-components';

// TODO: Refactor the whole file to use styled components

const OrderedList = styled.ol`
  counter-reset: item;
  list-style-type: none;
  margin-top: 0;

  & > li {
    counter-increment: item;
    position: relative;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0px;
    }
  }

  & > li::before {
    content: '${(props) => props.digit}.' counter(item) ' ';
    position: absolute;
    left: -42px;
    // --size: 32px;
    // left: calc(-1 * var(--size) - 10px);
  }

  ol {
    margin: 8px 0;

    & > li {
      margin-bottom: 8px;
      padding-left: 10px;

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`;

const Warning = styled.p`
  color: rgb(200, 0, 0);
  margin: 0 0 12px;
`;

class TermsAndConditions extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <React.Fragment>
        <div
          style={{
            maxWidth: '1024px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Grid
            spacing={0}
            container
            alignItems={'center'}
            justify={'center'}
            spacing={0}
            className="template-terms"
          >
            <Grid item md={12} sm={11} xs={11}>
              <span className="last-update">
                <span className="t-weight-b">Last update:</span> 5 May 2021
              </span>
              <h1 className="template-terms-main-title">Terms & Conditions</h1>

              <TermsItem title="Luminaire Broker Terms of Service">
                <p className="template-terms-row-text">
                  This is a legal agreement between you, a corporate entity
                  <b> (“User”)</b>, and Ove Arup & Partners International
                  Limited
                  <b> (“Arup”) </b>
                  whose registered office is at 8 Fitzroy Street, London, W1T
                  4BJ, United Kingdom. It sets out the basis on which you may
                  use the Luminaire Broker service. By using these Services, you
                  are deemed to have accepted the terms of this agreement.
                </p>
                <p className="template-terms-row-text">
                  Please read these terms carefully. They contain important
                  information about your account, the content you may upload,
                  and the rights and liabilities of you, Arup and other users of
                  the Services.
                </p>
                <p className="template-terms-row-text">
                  Arup may make changes to the Services and/or these terms and
                  conditions from time to time by updating this page. Whilst we
                  will try to notify you of any material changes, we may not
                  notify you of every change. You should check this page from
                  time to time to ensure you remain happy with these terms.
                </p>
              </TermsItem>
              <TermsItem title="Definitions" olTitle>
                <p className="template-terms-row-text">
                  <b>Authorised Individual</b> – those employees, agents and
                  independent contractors of the User who are authorised by the
                  User to use the Services.
                </p>
                <p className="template-terms-row-text">
                  <b>Business Day</b> – a weekday which is not a public holiday
                  in England.
                </p>
                <p className="template-terms-row-text">
                  <b>Content</b> – the data, information or other material
                  inputted by the User and/or Authorised Individuals for the
                  purpose of using the Services or facilitating the User's use
                  of the Services.
                </p>
                <p className="template-terms-row-text">
                  <b>Effective Date</b> – the date the User entered into this
                  Agreement.
                </p>
                <p className="template-terms-row-text">
                  <b>Services</b> – the Luminaire Broker, as defined in the
                  User’s Membership Plan.
                </p>
                <p className="template-terms-row-text">
                  <b>Membership Plan</b> – the membership plan entered into by
                  the User which makes reference to this Agreement, covering in
                  respect of each User the Services which may be accessed and
                  used by the User.
                </p>
                <p className="template-terms-row-text">
                  <b>Membership Term</b> – means the period from the Effective
                  Date until termination of this Agreement.
                </p>
              </TermsItem>
              <TermsItem title="1. Account Terms" olTitle>
                <OrderedList digit="1">
                  <li>
                    Subject to the User continuing to comply with the terms of
                    this Agreement, Arup hereby grants to the User a
                    non-exclusive, non-transferable right to permit the
                    Authorised Individuals to access and use the Services during
                    the Subscription Term solely for the User’s internal
                    business operations.
                  </li>
                  <li>
                    In order to register for access to the Services (or any time
                    thereafter upon Arup’s request), the User must provide
                    evidence of procedures that they have in place to:
                    <ol type="a">
                      <li>
                        ensure that their manufacturing facilities are managed
                        in terms of quality assurance, in compliance with the
                        international ISO 9001:2015 standard (or equivalent,
                        subject to Arup’s approval); and
                      </li>
                      <li>
                        manage waste and other environmental issues resulting
                        from the manufacturing process, in compliance with the
                        requirements of the international ISO 14001:2015
                        standard (or equivalent, subject to Arup’s approval).
                      </li>
                    </ol>
                  </li>
                  <li>
                    In relation to each of the Authorised Individuals, the User
                    undertakes that:
                    <ol type="a">
                      <li>
                        a name, a valid email address, and any other information
                        requested by Arup will be provided.
                      </li>
                      <li>
                        each login may only be used by one natural person - a
                        single login shared by multiple people is not permitted,
                        and Arup does not allow for logins or accounts to be
                        operated by “bots”. The User may create separate logins
                        for as many people as the User’s Membership Plan allows.
                        If the User’s Membership Plan is silent on a maximum
                        number of separate logins the User may create as many as
                        is reasonable and proportionate having regard to: (i)
                        the size of the User’s organisation; and (ii) the nature
                        of the User’s ordinary business operations. Arup
                        reserves the right to decide, at its sole discretion,
                        what constitutes “reasonable and proportionate” for the
                        purposes of this clause.{' '}
                      </li>
                      <li>
                        each Authorised Individual is responsible for
                        maintaining the security of their account and password.
                        Arup cannot and will not be liable for any loss or
                        damage from the User’s failure to comply with this
                        security obligation.
                      </li>
                    </ol>
                  </li>
                  <li>
                    The User is responsible for all Content inputted and
                    activity that occurs under the User’s account, even when
                    Content is posted by others who have accounts under the
                    User’s account or by unauthorised third parties using the
                    User’s account. The User must not:
                    <ol type="a">
                      <li>
                        use the Services for any illegal or unauthorised
                        purpose.
                      </li>
                      <li>
                        in the use of the Services, violate any laws in the
                        User’s jurisdiction (including but not limited to
                        copyright or trademark laws).
                      </li>
                      <li>
                        modify, adapt or hack the Services or modify another
                        website so as to falsely imply that it is associated
                        with the Services, Arup, or any other Arup service.
                      </li>
                      <li>
                        reproduce, duplicate, copy, sell, resell or exploit any
                        portion of the Services, use of the Services, or access
                        to the Services without the express written permission
                        by Arup.
                      </li>
                      <li>
                        upload, post, host, or transmit unsolicited email, SMSs,
                        "spam" messages or any material that is offensive,
                        threatening, libellous, defamatory, pornographic,
                        obscene or otherwise objectionable.
                      </li>
                      <li>
                        transmit any worms or viruses or any code of a
                        destructive nature.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Technical support is provided via email and phone during
                    “business hours”, as defined in clause 15.2. Arup may revise
                    the support services at its sole and absolute discretion
                    from time to time.
                  </li>
                  <li>
                    The User understands and agrees that:
                    <ol type="a">
                      <li>
                        Arup uses partners to provide the necessary hardware,
                        software, networking, storage, and related technology
                        third-party vendors and hosting required to run the
                        Service; and
                      </li>
                      <li>
                        the technical processing and transmission of the
                        Services, including the User Content, may be transferred
                        unencrypted and involve (i) transmissions over various
                        networks; and (ii) changes to conform and adapt to
                        technical requirements of connecting networks or
                        devices.
                      </li>
                      <li>
                        While Arup prohibits offensive conduct and Content
                        posted on the Services, Arup cannot be responsible for
                        the Content inputted on the Services and the User
                        nonetheless may be exposed to such materials. The User
                        agrees to use the Services at the User’s own risk.
                      </li>
                      <li>
                        Where the Services include or are based on data provided
                        by third parties, Arup only accepts liability for the
                        output of the Services containing or based on such data
                        to the extent that it has expressly accepted any such
                        liability by separate agreement with the User in
                        writing.{' '}
                      </li>
                    </ol>
                  </li>
                  <li>
                    The User may use the Arup pages static hosting service
                    solely as permitted and intended to host the User
                    organisation pages, personal pages, or project pages, and
                    for no other purpose. The User may not use Arup pages in
                    violation of Arup's trademark or other rights or in
                    violation of applicable law.
                  </li>
                  <li>
                    Arup and its hosting providers will take all reasonable
                    measures to safeguard the User’s Content. The User will use
                    all reasonable endeavours to ensure that Authorised
                    Individuals, maintain back-up copies of any Content for
                    archive and roll-back purpose.
                  </li>
                  <li>
                    Arup may, but have no obligation to, remove Content and
                    accounts containing Content that it determines in its sole
                    discretion infringes the conditions under clause 1.4 or any
                    of the terms under this Agreement.
                  </li>
                  <li>
                    Arup reserves the right to temporarily disable the User’s
                    account if the User’s usage significantly exceeds the
                    average usage of other Service Users or such other usage
                    criteria as have been agreed with the User in writing. Arup
                    will contact the account owner before taking any action
                    except in rare cases where the level of use may negatively
                    impact the performance of the Service for other Users or for
                    Arup.
                  </li>
                  <li>
                    If Arup makes material changes to these terms, it will
                    notify the User by email or by posting a notice on the
                    Luminaire Broker site before the changes are effective. Any
                    new features that augment or enhance the current Services,
                    including the release of new tools and resources, shall be
                    subject to these terms and conditions. Continued use of the
                    Services after any such changes shall constitute the User’s
                    consent to such changes.
                  </li>
                  <li>
                    The User acknowledges that the Services are subject to
                    continuous development and change of specification without
                    notice. Notwithstanding the foregoing, Arup will give
                    reasonable notice of any material change to the
                    specification or any functionality or API call prior to
                    implementing such change. A change shall not be material
                    unless, when implemented, it is likely to negatively impact
                    on the User’s use of the Services.
                  </li>
                  <li>
                    The User may not access the Services other than through the
                    documented user interface. Unless the User has been granted,
                    and has paid for, API access as set out in clause 2 below,
                    the User may not access the Services programmatically. In
                    particular, the User may not use any form of “screen
                    scraper” or other automated process to access any part of
                    the Services’ human-machine interface. The User may not
                    attempt, or cause any third party to attempt, to access the
                    services for penetration testing or other security or
                    performance-related purposes without the prior written
                    permission of Arup, which may be withheld or conditioned at
                    Arup’s absolute discretion.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="2. API Terms" olTitle>
                <Warning>
                  NOTE: API access as envisioned by this clause 2 is not
                  currently available. Please check again soon.{' '}
                </Warning>
                <OrderedList digit="2">
                  <li>
                    Where Arup provides the facility and where agreed as part of
                    the User’s Membership Plan, the User may access its account
                    data via an Application Programming Interface (API). Any use
                    of the API, including use of the API through a third-party
                    product that accesses an Arup service, is bound by these
                    terms and conditions plus the following specific terms:
                  </li>
                  <li>
                    The User expressly understands and agrees that Arup shall
                    not be liable for any direct, indirect, incidental, special,
                    consequential or exemplary damages, including but not
                    limited to, damages for loss of profits, goodwill, use, data
                    or other intangible losses (even if Arup has been advised of
                    the possibility of such damages), resulting from the User’s
                    use of the API or third-party products that access data via
                    the API.
                  </li>
                  <li>
                    Abuse or excessively frequent requests to the Services via
                    the API may result in the temporary or permanent suspension
                    of the User’s account access to the API. Arup, in its sole
                    discretion, will determine abuse or excessive usage of the
                    API. Arup will make a reasonable attempt via email to warn
                    the account owner prior to suspension.
                  </li>
                  <li>
                    The User shall not access or attempt to access the API other
                    than through the documented interface.
                  </li>
                  <li>
                    Any tokens provided by Arup to authenticate and grant access
                    to any API are proprietary to and the confidential
                    information of Arup. Such tokens shall be used solely to
                    access the API as expressly permitted by this Agreement and
                    the User’s shall be responsible for all use under any token
                    issued to it whether authorised or not until the User has
                    notified Arup that any such token has been compromised.
                    Should any token be incorporated into software (as permitted
                    by the terms applicable to the documented interface), the
                    User shall take all reasonable steps to obfuscate the token
                    within the software.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem
                title="3. Access to Luminaire Broker under a Paid-for Commission with Arup"
                olTitle
              >
                <p className="template-terms-row-text">
                  If and to the extent the User accesses the Services as part of
                  (or in connection with) a separate agreement with Arup (or any
                  other company in the “Arup” group of companies) for the
                  performance of professional services (“<b>Arup Commission</b>
                  ”), for the avoidance of doubt:
                </p>
                <ol type="a">
                  {/* FIXME: Temporary solution until the file is refactored */}
                  <li style={{ paddingLeft: '10px', marginBottom: '8px' }}>
                    this Agreement alone shall govern the User’s access to and
                    use of the Services; and
                  </li>
                  <li style={{ paddingLeft: '10px' }}>
                    the Arup Commission shall be subject solely to such terms as
                    are agreed separately by the parties in writing.{' '}
                  </li>
                </ol>
              </TermsItem>
              <TermsItem title="4. Term, Cancellation and Termination" olTitle>
                <OrderedList digit="4">
                  <li>
                    This Agreement commences on the Effective Date and shall
                    continue for the Membership Term.
                  </li>
                  <li>
                    Without affecting any other right or remedy available to it,
                    Arup may immediately terminate this Agreement or any
                    Services if the User has: (a) breached any term of this
                    Agreement; or (b) used or permitted the use of the Services
                    otherwise than in accordance with this Agreement. Such
                    termination will result in the deactivation or deletion of
                    the User’s account or the User’s access to the User’s
                    account, and the forfeiture and relinquishment of all
                    Content in the User’s account.
                  </li>
                  <li>
                    Either party may terminate this Agreement if the other party
                    has a receiver or administrative receiver appointed of it or
                    over any part of its undertaking or assets or shall pass a
                    resolution for winding up (otherwise than for the purpose of
                    a bona fide scheme of solvent amalgamation or
                    reconstruction) or a court of competent jurisdiction shall
                    make an order to that effect or if such party enters into
                    any voluntary arrangement with its creditors or shall become
                    subject to an administration order.
                  </li>
                  <li>
                    The User can cancel the User’s account at any time via the
                    User’s account settings, thereby terminating this Agreement.
                    The User is solely responsible for properly cancelling their
                    account; an email or phone request to cancel the User’s
                    account is not considered cancellation.
                  </li>
                  <li>
                    All of User’s login details and user accounts will be
                    deleted from the Services upon cancellation, and all Content
                    in the User’s account shall be forfeited and relinquished.
                    This information cannot be recovered once the User’s account
                    is cancelled.
                  </li>
                  <li>
                    Arup may suspend the provision of Services without notice,
                    without prejudice to the termination rights set out in this
                    Agreement, should either the right to terminate have arisen,
                    or Arup reasonably determines that its right to terminate is
                    imminent.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="5. Copyright and Content Ownership" olTitle>
                <OrderedList digit="5">
                  <li>
                    The User acknowledges and agrees that Arup and/or its
                    licensors own all intellectual property rights in the
                    Services and any and all related software. Except as
                    expressly stated herein, this Agreement does not grant the
                    User any rights to, or in, patents, copyright, database
                    right, trade secrets, trade names, trade marks (whether
                    registered or unregistered), or any other rights or licences
                    in respect of the Services. This is an access licence, and
                    is not a licence to software, so no rights to decompile etc.
                    any software arise by virtue of the Software Directive
                    2009/24/EC or otherwise.{' '}
                  </li>
                  <li>
                    Arup claim no intellectual property rights over the
                    materials the User provides in respect to the Services. The
                    User’s profile and materials uploaded remains the property
                    of the User.
                  </li>
                  <li>
                    The User grants (or undertakes to procure the grant) to Arup
                    a non-exclusive, royalty free licence to use any and all
                    Content, proprietary materials, data feeds or items
                    necessary to provide the Services, if any. Subject to
                    maintaining confidentiality in accordance with this
                    Agreement, Arup may use any Content in connection with
                    providing the Services, and any other products or services
                    agreed between the parties, as Arup may require.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="6. Indemnity" olTitle>
                <OrderedList digit="6">
                  <li>
                    The User shall defend, indemnify and hold harmless Arup
                    against claims, actions, proceedings, losses, damages,
                    expenses and costs (including without limitation court costs
                    and reasonable legal fees) arising out of or in connection
                    with any claim from a third party relating to the User’s use
                    or misuse of the Services, or any use or misuse of the
                    Services arising from the User’s default, or any claim of
                    breach of copyright, database right or other intellectual
                    property right arising out of Arup’s use of any data or
                    content which the User has purported to license or provide a
                    licence for under clause 5.3 provided that:
                    <ol type="a">
                      <li>
                        the User is given prompt notice of any such claim;
                      </li>
                      <li>
                        Arup provides reasonable co-operation to the User in the
                        defence and settlement of such claim, at the User’s sole
                        expense; and
                      </li>
                      <li>
                        the User is given sole authority to defend or settle the
                        claim.
                      </li>
                    </ol>
                  </li>
                  <li>
                    In no event shall Arup, its employees, agents and
                    sub-contractors be liable to the User to the extent that the
                    alleged infringement is based on:
                    <ol type="a">
                      <li>
                        a modification of the Services by anyone other than
                        Arup; or
                      </li>
                      <li>
                        the User’s use of the Services is in a manner contrary
                        to the instructions given to the User by Arup or
                        otherwise than in accordance with this Agreement; or
                      </li>
                      <li>
                        the User’s use of the Services after notice of the
                        alleged or actual infringement from the Supplier or any
                        appropriate authority.
                      </li>
                    </ol>
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="7. Limitation of Liability" olTitle>
                <OrderedList digit="7">
                  <li>
                    The Services are made available to the User free of charge
                    on the basis that no representations or warranties express
                    or implied are made regarding their performance, the
                    accuracy or completeness of the data and/or information
                    contained therein or the outputs, and the Services are
                    provided strictly on an “as is” basis. In particular, Arup
                    does not warrant that:
                    <ol type="i">
                      <li>
                        the Services will meet the User’s specific requirements;{' '}
                      </li>
                      <li>
                        the Services will be uninterrupted, timely, secure, or
                        error-free;
                      </li>
                      <li>
                        the results that may be obtained from the use of the
                        Services will be accurate or reliable;{' '}
                      </li>
                      <li>
                        the quality of any products, services, information, or
                        other material purchased or obtained by the User through
                        the Services will meet the User’s expectations; or{' '}
                      </li>
                      <li>any errors in the Services will be corrected.</li>
                    </ol>
                  </li>
                  <li>
                    The User expressly understands and agrees that Arup shall
                    not be liable for (a) any loss of profits, loss of goodwill,
                    loss of use, or loss/corruption of data and/or (b) indirect,
                    incidental, special, consequential or exemplary damages, or
                    other intangible losses (even if Arup has been advised of
                    the possibility of such damages), resulting from: (i) the
                    use or the inability to use the service; (ii) the cost of
                    procurement of substitute goods and services resulting from
                    any goods, data, information or services purchased or
                    obtained or messages received or transactions entered into
                    through or from the service; (iii) unauthorized access to or
                    alteration of the User’s transmissions or data; (iv)
                    statements or conduct of any third-party on the service; (v)
                    or any other matter relating to the Services.
                  </li>
                  <li>
                    All warranties, representations, conditions and all other
                    terms of any kind whatsoever implied by statute or common
                    law are, to the fullest extent permitted by applicable law,
                    excluded from this Agreement.
                  </li>
                  <li>
                    Nothing in this Agreement excludes Arup’s liability for:
                    <ol type="a">
                      <li>
                        death or personal injury caused by the Supplier's
                        negligence; or
                      </li>
                      <li>fraud or fraudulent misrepresentation. </li>
                    </ol>
                  </li>
                  <li>
                    Subject to clause 7.4, Arup’s total aggregate liability in
                    contract (including in respect of the indemnity at clause
                    6), tort (including negligence or breach of statutory duty),
                    misrepresentation, restitution or otherwise, arising in
                    connection with the performance or contemplated performance
                    of this Agreement shall be limited to the sum of £100.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="8. Data Sharing and Confidentiality" olTitle>
                <OrderedList digit="8">
                  <li>
                    Each party shall retain in confidence and require its
                    employees, agents and contractors, to retain in confidence
                    all information contained in the Services and all
                    information and know-how, regardless of form, transmitted to
                    such party that the disclosing party has identified as being
                    proprietary and/or confidential or which, by the nature of
                    the circumstances surrounding the disclosure, ought in good
                    faith to be treated as proprietary and/or confidential
                    (“Confidential Information”). The receiving party shall
                    retain Confidential Information in as secure a manner as
                    reasonably possible, but in no event less secure than the
                    receiving party retains its own Confidential Information.
                    Confidential Information shall remain the sole property of
                    the disclosing party and shall not be disclosed to any third
                    party without the express written consent of the disclosing
                    party (except, solely for the receiving party’s internal
                    business needs, to consultants who are bound by a written
                    agreement with the receiving party to maintain the
                    confidentiality of such Confidential Information in a manner
                    consistent with this Agreement).
                  </li>
                  <li>
                    Confidential Information shall not include any information
                    that:
                    <ol type="i">
                      <li>
                        is at the time of disclosure or subsequently becomes
                        publicly available without the receiving party’s breach
                        of any obligations owed the disclosing party;
                      </li>
                      <li>
                        became known to the receiving party prior to the
                        disclosing party’s disclosure of such information to the
                        receiving party;
                      </li>
                      <li>
                        became known to the receiving party from a source other
                        than the disclosing party other than by the breach of an
                        obligation of confidentiality owed to the disclosing
                        party;
                      </li>
                      <li>
                        is independently developed by the receiving party; or
                      </li>
                      <li>
                        is produced in compliance with applicable law or a court
                        order, provided the other party is given reasonable
                        notice of such law or order and an opportunity to
                        attempt to preclude or limit such production. This
                        Agreement constitutes the proprietary information of
                        Arup. This clause shall survive termination of the
                        Agreement.
                      </li>
                    </ol>
                  </li>
                  <li>
                    In carrying out the Services, Arup will have access to and
                    acquire the Content. The User agrees to give Arup access to
                    such Content on a continuous basis and/or on request using
                    such means or methods as are set out under the Agreement
                    (including programmatic API access).
                  </li>
                  <li>
                    The Users grants to Arup a perpetual, irrevocable,
                    royalty-free, non-exclusive, worldwide licence to extract,
                    store, analyse, copy and publish the results of the analysis
                    and extracts of the Content, subject always to the
                    restrictions set out under this clause 8 and clause 10
                    below. Arup may analyse the Content (alone and in
                    combination with other data) for any purpose at any time.
                    The User shall have no rights in the analysis of such
                    Content.
                  </li>
                  <li>
                    Arup shall keep the Content confidential in accordance with
                    the confidentiality obligations as set out in this clause 8.
                    However, such obligation of confidentiality shall not apply
                    to the publication or dissemination of a subset of the
                    Content, or the results of the analysis of the Content
                    (including an analysis involving other data) (‘Results’);
                    provided that the Results are not identified or,
                    identifiable with a specific User, structure or project.
                  </li>
                  <li>
                    Where the Content includes personal data (within the
                    definition of the relevant data protection laws, including
                    the UK Data Protection Act or the General Data Protection
                    Regulation), such Content shall be dealt in accordance with
                    applicable data protection laws as set out in clause 10
                    below.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="9. Conflict" olTitle>
                <p className="template-terms-row-text">
                  If there is an inconsistency between any of the provisions in
                  the main body of this Agreement and the Membership Plan, the
                  provisions in this Agreement shall prevail.
                </p>
              </TermsItem>
              <TermsItem title="10. Data Protection" olTitle>
                <OrderedList digit="10">
                  <li>
                    Where applicable, each party undertakes to comply with its
                    obligations under any relevant data protection laws
                    including (where applicable) the UK Data Protection Act 1998
                    or the General Data Protection Regulation.
                  </li>
                  <li>
                    If Arup processes any personal data on the User’s behalf
                    when performing its obligations under this Agreement, the
                    parties record their intention that the User shall be the
                    data controller and Arup shall be a data processor and in
                    any such case:
                    <ol type="a">
                      <li>
                        the User acknowledges and agrees that the personal data
                        may be transferred or stored in the country where the
                        User and the Authorised Individuals are located and
                        outside of the European Economic Area in order to carry
                        out the Services and Arup’ other obligations under this
                        Agreement;
                      </li>
                      <li>
                        the User shall ensure that the User is entitled to
                        provide the relevant personal data to Arup so that Arup
                        may lawfully use, process and transfer the personal data
                        to perform its obligations under this Agreement;
                      </li>
                      <li>
                        the User shall ensure that the relevant third parties
                        have been informed of, and where necessary, have given
                        their consent to, such use, processing and transfer as
                        required by all applicable data protection laws;
                      </li>
                      <li>
                        each party shall take appropriate technical and
                        organisational measures against unauthorised or unlawful
                        processing of the personal data or its accidental loss,
                        destruction or damage.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Where appropriate and agreed between the parties the terms
                    of this clause 10 shall be supplemented by a Data Processing
                    Agreement in a form to be supplied by Arup.
                  </li>
                  <li>
                    the Content and Authorised Individuals’ login information
                    described in clause 1.3 shall, to the extent it constitutes
                    personal data, be collected and used by Arup subject to the
                    terms of the{' '}
                    <Link to="/privacy-policy">Privacy Notice</Link>.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="11. No Waiver" olTitle>
                <p className="template-terms-row-text">
                  No delay, neglect or forbearance on the part of either party
                  in enforcing against the other party any term of this
                  Agreement shall either be or be deemed to be a waiver or in
                  any way prejudice any right of the party under this Agreement.
                </p>
              </TermsItem>
              <TermsItem title="12. Severability" olTitle>
                <p className="template-terms-row-text">
                  If it is held under any enactment or rule of law that any
                  provision of this Agreement is void or otherwise ineffective
                  in whole or in part then any other part and the other terms of
                  this Agreement shall continue in full force and effect.
                </p>
              </TermsItem>
              <TermsItem title="13. Entire Agreement" olTitle>
                <p className="template-terms-row-text">
                  This Agreement is the complete and exclusive statement of the
                  agreement between the User and Arup which supersedes all
                  proposals or prior agreements oral or written save any
                  expressly agreed terms that have been signed by an authorised
                  representative of Arup and the User and save as expressly set
                  out in this Agreement all representations, conditions or
                  warranties express or implied statutory or otherwise are
                  excluded, to the maximum extent permitted by law.
                </p>
              </TermsItem>
              <TermsItem title="14. Variation" olTitle>
                <p className="template-terms-row-text">
                  A purported variation of this Agreement is not effective
                  unless in writing signed by an authorised senior
                  representation of both parties.
                </p>
              </TermsItem>
              <TermsItem title="15. Notices" olTitle>
                <OrderedList digit="15">
                  <li>
                    Any notice or consent required or given under this Agreement
                    shall be in writing, in English, either personally delivered
                    or sent by email (to an appropriately senior representative
                    of the receiving party) or by first class airmail, and sent
                    to the registered address of the receiving party or such
                    other address as such party may from time to time designate
                    by notice to the other party.
                  </li>
                  <li>
                    Communications shall be deemed to have been received as
                    follows:
                    <ol type="a">
                      <li>
                        (if sent by post) three Business Days after posting;
                      </li>
                      <li>
                        (if delivered by hand) on the day of delivery, if
                        delivered at least two hours before the close of
                        business hours on a Business Day, and otherwise on the
                        next Business Day;
                      </li>
                      <li>
                        (if sent by email) upon receipt of an acknowledgement
                        email confirming the receipt of the email message, if
                        received at least two hours before the close of business
                        hours on a Business Day, and otherwise on the next
                        Business Day. An automatic reply shall not be deemed as
                        the acknowledgement of an email message.
                      </li>
                    </ol>
                  </li>
                  <p className="template-terms-row-text">
                    In this Agreement, “business hours” means between the hours
                    of 09.00 and 17:30 GMT on a Business Day.
                  </p>
                </OrderedList>
              </TermsItem>
              <TermsItem title="16. Third Party Rights" olTitle>
                <p className="template-terms-row-text">
                  The parties do not intend that any term of this Agreement
                  shall be enforceable by virtue of the Contracts (Rights of
                  Third Parties) Act 1999 by any person who is not a party to
                  this Agreement.
                </p>
              </TermsItem>
              <TermsItem title="17. Assignment" olTitle>
                <OrderedList digit="17">
                  <li>
                    The User shall not, without our prior written consent,
                    assign, transfer, charge, sub-contract or deal in any other
                    manner with all or any of its rights or obligations under
                    this Agreement.
                  </li>
                  <li>
                    Arup may at any time assign, transfer, charge, sub-contract
                    or deal in any other manner with all or any of its rights or
                    obligations under this Agreement.
                  </li>
                </OrderedList>
              </TermsItem>
              <TermsItem title="18. Law" olTitle>
                <OrderedList digit="18">
                  <li>
                    This Agreement shall be governed by and construed in
                    accordance with the laws of England and Wales.
                  </li>
                  <li>
                    The English courts shall have exclusive jurisdiction to
                    determine any disputes which may arise out of, under, or in
                    connection with this Agreement.
                  </li>
                </OrderedList>
              </TermsItem>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default TermsAndConditions;
